import React from 'react';
import { Progress } from '@umu/umu-design';
import { If } from 'common/src/components';
interface IProps {
    value: number;
    config: Record<string, any>;
}
const ProgressElement = (props: IProps) => {
    const { value, config } = props;
    const percent = (Number(value) * 100).toFixed(2).replace(/\.00$/, '');
    return (
        <div className={`ele-render-type-progress-info ${config.className || ''}-progress-info`}>
            <Progress {...config} percent={Number(percent)} />
            <If condition={!!config?.isShowLabel}>
                <div className="ele-render-type-progress-info-label">{`${percent}%`}</div>
            </If>
        </div>
    );
};
export { ProgressElement };
